import { getScreenByToken, verifyTokenRole } from 'config/tokenRouter' // , verifyTokenRole } from 'config/tokenRouter'
import { get, URL_VARIABLES } from 'services/api'

export default async function validateStageOnboarding(
  token,
  history,
  role,
  setLoading,
) {
  setLoading(true)
  try {
    const res = await get({
      url: `/onboarding/stage/validate`,
      token,
      source: URL_VARIABLES.ANTIFRAUDE,
    })

    if (res && res.status === 200) {
      const { identity } = getScreenByToken(res.data.token)

      if (!identity || identity?.screen === role) 
        return
      
      verifyTokenRole(token, history)
    }
  } finally {
    setLoading(false)
  }
}
